module.exports = __webpack_public_path__ + "pc/img/main_work_img3.25142ec0.jpg";